import type { SpacingOptions } from '@mui/system';

const spacingScale: number[] = [
  0, 2, 4, 6, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80, 96, 128, 160,
];

const maxScaleIndex = spacingScale.length - 1;
const fallbackStep = spacingScale[maxScaleIndex] - spacingScale[maxScaleIndex - 1];

// Interpolates the bespoke spacing scale so fractional factors stay smooth.
const resolveSpacingValue = (factor: number): number => {
  if (Number.isInteger(factor)) {
    const token = spacingScale[factor];
    if (token !== undefined) {
      return token;
    }
  }

  if (factor >= 0 && factor < maxScaleIndex) {
    const lowerIndex = Math.floor(factor);
    const upperIndex = lowerIndex + 1;
    const lowerValue = spacingScale[lowerIndex];
    const upperValue = spacingScale[upperIndex];
    const fraction = factor - lowerIndex;
    return lowerValue + (upperValue - lowerValue) * fraction;
  }

  const overflow = factor - maxScaleIndex;
  return spacingScale[maxScaleIndex] + overflow * fallbackStep;
};

export const spacing: SpacingOptions = (factor: number): string => {
  if (!Number.isFinite(factor) || factor === 0) {
    return '0px';
  }

  const absoluteValue = Math.abs(factor);
  const resolved = resolveSpacingValue(absoluteValue);
  const signedValue = factor < 0 ? -resolved : resolved;

  return `${signedValue}px`;
};
